// @ts-nocheck
import * as React from 'react';
import { Children, cloneElement, memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import {
    AppBar as MuiAppBar,
    IconButton,
    Toolbar,
    Tooltip,
    Typography,
    useMediaQuery,
    Theme,
} from '@material-ui/core';
import { AppBarProps as MuiAppBarProps } from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import { toggleSidebar, useTranslate } from 'ra-core';
import MystarNavigationBar from "./MystarNavigationBar";
import {
    useAuthenticated, useAuthState, Loading
} from 'react-admin';

const useStyles = makeStyles(
    theme => ({
        appBar: {
            border: 0,
            background: '#000',
            width: '100vw',
            // maxWidth: '2500px'
        },
        toolbar: {
            paddingRight: 24,
        },
        menuButton: {
            display: 'none',
            marginLeft: '0.5em',
            marginRight: '0.5em',
        },
        menuButtonIconClosed: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            transform: 'rotate(0deg)',
        },
        menuButtonIconOpen: {
            transition: theme.transitions.create(['transform'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            transform: 'rotate(180deg)',
        },
        title: {
            flex: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
    }),
    { name: 'RaAppBar' }
);

const MystarAppBar = (props: MystarAppBarProps): JSX.Element => {

    const {
        children,
        className,
        color = 'secondary',
        logout,
        open,
        title,
        userMenu,
        ...rest
    } = props;
    const classes = useStyles(props);
    const dispatch = useDispatch();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('xs')
    );
    const translate = useTranslate();

    return (
        <MuiAppBar position={'relative'} className={classes.appBar} color={color} {...rest}>
            <Toolbar
                disableGutters
                variant={isXSmall ? 'regular' : 'dense'}
                className={classes.toolbar}
            >

                <Container
                    // style={{ maxWidth: '1230px' }}
                >
                    <MystarNavigationBar />
                </Container>

            </Toolbar>
            <Box display="flex" flexDirection="row" style={{backgroundColor: '#e7e6e7'}} >
                <Box m={2.5}></Box>
            </Box>
        </MuiAppBar>
    );
};

MystarAppBar.propTypes = {
    children: PropTypes.node,
    // @ts-ignore
    classes: PropTypes.object,
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'default',
        'inherit',
        'primary',
        'secondary',
        'transparent',
    ]),
    logout: PropTypes.element,
    open: PropTypes.bool,
    userMenu: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
};
export interface MystarAppBarProps
    extends Omit<MuiAppBarProps, 'title' | 'classes'> {
    classes?: ClassesOverride<typeof useStyles>;
    logout?: JSX.Element;
    open?: boolean;
    title?: string | JSX.Element;
    userMenu?: JSX.Element | boolean;
}

export default memo(MystarAppBar);
